import React from 'react';
import { CheckIcon, BookOpenIcon, MessagesSquareIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
const checks = ['Conceptos sin humo, explicados para que los entiendas de verdad.', '3 estrategias aplicables, no teoría suelta.', 'Guía de backtesting para validar antes de arriesgar.', 'Gestión de riesgo integrada desde el primer día.', 'Casos reales analizados, con aciertos y errores.'];
export function SolutionSection() {
  return <Section id="solucion" className="border-y border-white/5 bg-ink-900" data-id="element-189" data-mp="3t8df22wy5ztx">
      <Reveal data-id="element-190" data-mp="3t6aq7m7j6cqs">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-191" data-mp="3t6kf16guaduw">
          <span aria-hidden="true" data-id="element-192" data-mp="5uswwtttf5u8">🏆</span> Capital Consciente — Ebook + Discord
          + 3 Bonos
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-gray-400 sm:text-lg" data-id="element-193" data-mp="krse99egyd1w">
          Capital Consciente no es una promesa de resultados. Es el mismo camino
          de aprendizaje que encontrarías en una mentoría privada — conceptos
          claros, estrategias con fundamento, gestión de riesgo desde el primer
          día — sin pagar la barrera de entrada de $500 USD.
        </p>
      </Reveal>

      <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-194" data-mp="3faivhvu4kb2p">
        <Reveal delay={0.05} data-id="element-195" data-mp="3ka57y324pnag">
          <div className="h-full rounded-2xl border border-white/10 bg-ink-850 p-6" data-id="element-196" data-mp="3kbgajzju8ozz">
            <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-brand-soft" data-id="element-197" data-mp="3p9zw3yuiryrt">
              <BookOpenIcon className="h-5 w-5 text-brand" data-id="element-198" data-mp="3u7ro0sv5zkw0" />
            </div>
            <h3 className="font-display text-lg font-bold text-white" data-id="element-199" data-mp="2u5hudf7zvzi">
              📘 Ebook
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-400" data-id="element-200" data-mp="6w0f96u15p80">
              Conceptos básicos + 3 estrategias + guía de backtesting.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.12} data-id="element-201" data-mp="gtewh8ns2i1d">
          <div className="h-full rounded-2xl border border-white/10 bg-ink-850 p-6" data-id="element-202" data-mp="gupzv7db9nry">
            <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-brand-soft" data-id="element-203" data-mp="2cw1k96lwbhtg">
              <MessagesSquareIcon className="h-5 w-5 text-brand" data-id="element-204" data-mp="27yhvvdvhhons" />
            </div>
            <h3 className="font-display text-lg font-bold text-white" data-id="element-205" data-mp="2mn4ky7awxus7">
              💬 Discord
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-400" data-id="element-206" data-mp="2hvml5mkmm08t">
              Análisis y actualizaciones continuas. No señales, no promesas.
            </p>
          </div>
        </Reveal>
      </div>

      <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-207" data-mp="2rknyt63p85jm">
        {checks.map((c, i) => <Reveal key={c} delay={i * 0.05} data-id="element-208" data-mp="35lqm1m6fjlw4" data-mpi={i}>
            <li className="flex items-start gap-3" data-id="element-209" data-mp="35je59ccerhkn">
              <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-brand-soft" data-id="element-210" data-mp="30m48tcqlq5nb">
                <CheckIcon className="h-4 w-4 text-brand" data-id="element-211" data-mp="1b88uzp6tg6wc" />
              </span>
              <span className="text-sm text-gray-300 sm:text-base" data-id="element-212" data-mp="1696213441r4q">{c}</span>
            </li>
          </Reveal>)}
      </ul>
    </Section>;
}